import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterEvents',
  pure: true // Ensure pipe is pure // detect the change only when the input passed to the pipe is being changed.
})
export class FilterEventsPipe implements PipeTransform {

  transform(events: any[], sval: any, viewBy: string,name?:any): any[] {
    if (!events || !sval || !viewBy) {
      return events; // Handle undefined or null cases gracefully
    }
    switch (viewBy) {
      case 'category':
        
        return events.filter(event => event.j_sc == sval.s_n && event.j_c === sval.j_c);
  
      case 'location':
        return events.filter(event => event.add == sval.name);
  
      case 'user':
        return events
        .map((event, index) => ({ ...event, index })) // Add index to each object
        .filter(event => event.em_i == sval.em_i); 
        // return events.filter(event => event.em_i == sval.em_i);
  
      case 'company':
        // for company check company id and name both
        return events.filter(event => (event.co_i == sval.id)||(event.company_name==sval.name));
  
      case 'c_user':
        return events.filter(event => (event.em_i == sval.em_i) && (event.company_name==name ));
  
      case 'c_category':
        return events.filter(event => (event.j_sc == sval.j_sc) && (event.company_name==name ) && event.j_c === sval.j_c);
      // case 'category':
      //   return events.filter(event => event.j_sc == sval.s_n && event.op_s !== 1);
  
      // case 'location':
      //   return events.filter(event => event.add == sval.name && event.op_s !== 1);
  
      // case 'user':
      //   return events.filter(event => event.em_i == sval.em_i && event.op_s !== 1);
  
      // case 'company':
      //   return events.filter(event => event.company_name == sval.company_name);
  
      // case 'c_user':
      //   return events.filter(event => event.em_i == sval.em_i && event.op_s !== 1);
  
      // case 'c_category':
      //   return events.filter(event => event.j_sc == sval.j_sc && event.op_s !== 1);
  
      default:
        return events; // Return all events if viewBy doesn't match any cases
    }
  }
}
